<template>
    <div id="calendar-week" 
        >
        <!-- 
            class="calendar-row-0-bad" 
            :class="'calendar-month-offset-'+firstOfWeekOffset" 
        -->
        <!-- <div class="calendar-week-name">{{pageName}}</div> -->

        <!--
        <div v-for="day in dateList.slice(0,7)" :key="`weekday-${day.getDate()}`"
            class="calendar-week-day-name calendar-row-0a"
            :class="calcColumn(day)">
            {{dayName(day)}}
        </div>
        -->
        <div v-for="cur in dateKeyRange.slice(0,7)" :key="cur.key"
            class="calendar-week-day-name calendar-row-0"
            :class="`calendar-col-${cur.col}`"
            >
            {{dayNameFromKey(cur.key, timezone)}}
        </div>

        <!-- <div v-for="day in dateList" :key="`day-${day.getDate()}`"
            class="calendar-week-day"
            :class="[{
                'calendar-before': isBeforeEvent(day),
                'calendar-after': isAfterEvent(day)
            },
                calcColumn(day)
            ]"> -->
        <div v-for="cur in dateKeyRange" :key="`day-${cur.key}`"
            class="calendar-week-day"
            :class="[{
                'calendar-inactive': !cur.during,
//                'calendar-before': isBeforeEvent(day),
//                'calendar-after': isAfterEvent(day)
            },    `calendar-col-${cur.col}`
//                calcColumn(day)
            ]">

            <div class="calendar-week-day-num calendar-item"
              :disabled="!cur.active"
              @click="cur.active ? doDay(cur.key) : null"
              title="View day"
            >{{cur.key.slice(-2)}}</div>

            <OverflowContainer :count="itineraryByDate[cur.key] ? itineraryByDate[cur.key].length : 0">
                <CalendarItem 
                    v-for="item in itineraryByDate[cur.key]" :key="`calitem-${item.id}`"
                    :item="item"
                    :timezone="timezone"                    
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" class="tiny" />
                    <CalendarItemDetailsShort 
                        :item="item"
                        :timezone="timezone"
                    />
                </CalendarItem>
            </OverflowContainer>

<!--
            <div class="calendar-week-day-num calendar-item"
              :disabled="isBeforeEvent(day) || isAfterEvent(day)"
              @click="doDay(day)"
              title="View day"
            >{{day.getDate()}}</div>

            <OverflowContainer :count="itemsForDay(day) ? itemsForDay(day).length : 0">
                <CalendarItem 
                    v-for="item in itemsForDay(day)" :key="`calitem-${item.id}`"
                    :item="item"
                    :timezone="timezone"                    
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" class="tiny" />
                    <CalendarItemDetailsShort 
                        :item="item"
                        :timezone="timezone"
                    />
                </CalendarItem>
            </OverflowContainer>
-->
        </div>
    </div>
</template>

<script>
import OverflowContainer from "@/components/OverflowContainer";
// import {dateToKey} from '@/utils/Sort';
// import {asNaiveDateISO} from '@/utils/DateTime';
import { dayNameFromKey, firstOfWeekObj, keyToLocalTime } from '@/utils/DateTime';

import {dateToKey} from '@/utils/Sort';
import CalendarIcon from "@/views/calendar/CalendarIcon";
import CalendarItem from "@/views/calendar/CalendarItem";
import CalendarItemDetailsShort from "@/views/calendar/CalendarItemDetailsShort";

// Default to showing the start month of the event
export default {
    name: "CalendarWeek",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        CalendarIcon,
        CalendarItem,
        CalendarItemDetailsShort,
        OverflowContainer,
    },
    computed: {
        dateKeyRange() {
            // Precalculate the key, col, active values
            /*
            let dtPage = new Date(this.pageDate);
            let first = new Date(dtPage);
            first.setDate(dtPage.getDate() - dtPage.getDay());  // 0-6 0==Sunday
            */
            let first = firstOfWeekObj(this.pageDate);  // , this.timezone);
            let firstKey = dateToKey(first);

            let keys = [
                {
                    key: firstKey,
                    col: 0,
                    during: this.eventDates.includes(firstKey),
                    active: this.activeDates.includes(firstKey)
                }
            ];
            for (let x=1; x<=6; x++) {
                let cur = keyToLocalTime(firstKey);
                // let cur = new Date(first);
                cur.setDate(first.getDate()+x);
                let curKey = dateToKey(cur);
                keys.push({
                    key: curKey,
                    col: x,
                    during: this.eventDates.includes(curKey),
                    active: this.activeDates.includes(curKey)
                });
            }
            return keys;
        },
        /*
        eventStart() {
            let dtStart = new Date(this.event.start_tz);
            //dtStart.setHours(0,0,0);
            return dtStart;
            // return new Date(this.event.start);
        },
        eventEnd() {
            let dtEnd = new Date(this.event.end_tz);
            // dtEnd.setHours(23,59,59);
            return dtEnd;
        },
        firstOfWeek() {
            // TODO: Convert this to TIMEZONE_AWARE!
            let first = new Date(this.pageDate);
            first.setDate( first.getDate() - this.firstOfWeekOffset );
            return first;
        },
        firstOfWeekOffset() {
            let dateObj = new Date(this.pageDate);
            return dateObj.getDay(); // 0-6 0==Sunday
        },
        lastOfWeek() {
            // TODO Week pagination
            return new Date(
                this.firstOfWeek.getYear(),
                this.firstOfWeek.getMonth(), // Zeroth day of next month (months are 0-indexed)
                this.firstOfWeek.getDate() + 6
            );
        },
        // daysInWeek() {
        //     return 7;
        // },
        dateList() {
            let dates = [];
            for (let x=0; x< 7; x++) {
                let curDate = new Date(this.firstOfWeek);
                curDate.setDate(this.firstOfWeek.getDate() + x);
                dates.push(curDate);
            }
            return dates;
        },
        monthNum() {
            return this.firstOfWeek.getMonth();
        },
        */
        // pageName() {
        //     return new Intl.DateTimeFormat(navigator.language, {month: 'long', year: 'numeric'}).format(this.firstOfWeek);
        // },
        // orderedByDay() {
        //     return groupByDate(this.items, 'start_time_utc', this.timezone);
        // },
    },
    methods: {
        dayNameFromKey,
        /*
        dayNameFromKey(dateKey) {
            return new Intl.DateTimeFormat(navigator.language, {weekday: 'long'}).format(new Date(dateKey));
        },

        calcColumn(dateObj) {
            return `calendar-col-${dateObj.getDay()}`;
        },
        dayName(dateObj) {
            return new Intl.DateTimeFormat(navigator.language, {weekday: 'long'}).format(dateObj);
        },
        isBeforeEvent(dateObj) {
            //console.log("IsBeforeEvent <", dateObj, this.eventStart, dateObj <= this.eventStart);
            let naiveDate = asNaiveDateISO(dateObj);
            return naiveDate < this.event.start; // STRING COMPARISON!
            // return dateObj < this.eventStart;
        },
        isAfterEvent(dateObj) {
            // console.log("IsAfterEvent >", dateObj, this.eventEnd, dateObj > this.eventEnd);
            let naiveDate = asNaiveDateISO(dateObj);
            return naiveDate > this.event.end; // STRING COMPARISON!
            // return dateObj > this.eventEnd;
        },
        itemsForDay(dateObj) {
            // let key = dateToKey(dateObj, this.timezone);
            let key = asNaiveDateISO(dateObj);
            return this.itineraryByDate[key];
        },
        */
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.items
            });
        },
        doDay(day) {
            this.$emit('day', day);
        }
    },
}
</script>

<style>
#calendar-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  background: #ddd;
  gap: 1px;
  border: 1px solid #ddd;
}

.calendar-week-name {
    grid-column: 1 / span 7;
    background: #fff;
    font-weight: bold;
}
.calendar-week-day-name {
    background: #fff;
    font-size: 12px;
    padding: 0 2px;
}
.calendar-week-day-num {
    padding: 0 2px;
}

.calendar-week-day {
    background: #fff;
    font-size: 12px;
    overflow: hidden;
    padding: 2px;
}

.calendar-inactive,
.calendar-before,
.calendar-after {
    background: #eee;
    /* color: #666; */
}


.calendar-col-0 { grid-column: 1;}
.calendar-col-1 { grid-column: 2;}
.calendar-col-2 { grid-column: 3;}
.calendar-col-3 { grid-column: 4;}
.calendar-col-4 { grid-column: 5;}
.calendar-col-5 { grid-column: 6;}
.calendar-col-6 { grid-column: 7;}

.calendar-row-0 { grid-row: 1;}
.calendar-row-1 { grid-row: 2;}


/* CalendarItem customisation! */
#calendar-week .calendar-schedule-detail { xdisplay: none;}

#calendar-week .calendar-item {
    xpadding: 5px;
}
#calendar-week .calendar-icon {
    margin-top: 1px;
    margin-right: 3px;;
}

#calendar-week .calendar-schedule-status {
    margin: 0 3px;
}

#calendar-week .calendar-schedule-detail {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>